document.addEventListener("DOMContentLoaded", function() {
    const CookieService = {
        setCookie(name, value, days) {
            let expires = '';
            if (days) {
                const date = new Date();
                date.setHours(23, 59, 59, 999);
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/;';
        },

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return null;
        }
    };

    if (document.getElementById('close-exit-intent-popup-2')) {
        document.getElementById('close-exit-intent-popup-2').addEventListener('click', function() {
            document.querySelector('.exit-intent-popup').classList.remove('visible');
        });
    }

    if (document.getElementById('close-exit-intent-popup-template')) {
        document.getElementById('close-exit-intent-popup-template').addEventListener('click', function() {
            document.querySelector('.exit-intent-popup').classList.remove('visible');
        });
    }

    const exitPopupDisabled = document.querySelector('.exit-intent-popup-disabled');

    if (exitPopupDisabled) {
        const timeoutSeconds = exitPopupDisabled.getAttribute('data-time') * 1000;
        if (!CookieService.getCookie('exitIntentShown')) {
            setTimeout(function() {
                exitPopupDisabled.classList.add('visible');
                CookieService.setCookie('exitIntentShown', 'true', 1);
            }, timeoutSeconds);
        }
    } else {
        if (!CookieService.getCookie('exitIntentShown') && document.querySelector('.exit-intent-popup')) {
            setTimeout(() => {
                document.addEventListener('mouseout', mouseEvent);
                document.addEventListener('keydown', exit);
                document.querySelector('.exit-intent-popup').addEventListener('click', exit);
            }, 0);
        }

        const exit = e => {
            if (e.target.classList.contains('exit-intent-popup') || e.target.className === 'exit-intent-popup-close' || e.keyCode === 27) {
                document.querySelector('.exit-intent-popup').classList.remove('visible');
            }
        };

        const mouseEvent = e => {
            if (!e.toElement && !e.relatedTarget && e.clientY < 3) {
                document.removeEventListener('mouseout', mouseEvent);
                document.querySelector('.exit-intent-popup').classList.add('visible');
                CookieService.setCookie('exitIntentShown', 'true', 1);
            }
        };

        const popup = document.querySelector('.exit-intent-popup');
        if (!CookieService.getCookie('exitIntentShown') && popup && window.screen.width < 576) {
            setTimeout(function() {
                popup.classList.add('visible');
                CookieService.setCookie('exitIntentShown', 'true', 1);
            }, 30000);
        }
    }
});
